export default __webpack_public_path__ + "static/media/ghost.2b923132.svg";